import Topbar from "../../components/topbar/Topbar";
import Sidebar from "../../components/sidebar/Sidebar";
import Feed from "../../components/feed/Feed";
import Rightbar from "../../components/rightbar/Rightbar";
import "./home.css"
import SocialContext from "../../context/SocialContext";
import { useNavigate } from 'react-router-dom';
import { useEffect, useContext } from "react";
import Bottom from "../../components/Bottom/Bottom";
import Alertjs from "../../components/alert/Alert";

export default function Home() {
  const navigate = useNavigate();
  const { isfetching, showalert, setshowalert, user, fetchcurrentuserfun, scrolltoTopfun } = useContext(SocialContext);

  useEffect(() => {
    if (!window.localStorage.getItem("currentUID"))
      navigate('/login');
    else {
      fetchcurrentuserfun();
    }
    scrolltoTopfun();
  }, [])

  return (
    <>
      <div style={{ 'display': 'none' }}>{window.document.title = 'Welcome | ' + user.username}</div>
      <Topbar />

      {showalert ? <div style={{ 'height': '45px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
        <Alertjs allertmessage={"Plese write something and try again..."} />
      </div> : ""}
      <div className="homeContainer">
        {isfetching ? "loading..." :
          <><Sidebar />
            <Feed />
            <Rightbar /></>
        }
      </div>
      <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
        <p style={{ 'textAlign': 'center', opacity: '0.6' }}>Copyright ©2022-Alok.info | All rights reserved</p>
      </div>
      <Bottom />
    </>
  );
}